/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { PIPRedirector }
from '@thd-nucleus/app-render';

import { ProductMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { DynamicRecsWrapperPip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { PIPProductDetails }
from '@thd-olt-component-react/product-details';

import { MediaGalleryDesktop }
from '@thd-olt-component-react/media-gallery';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { PIPSalientPoints }
from '@thd-olt-component-react/salient-points';

import { ProExtraProductOnly }
from '@thd-olt-component-react/pro-extra-product-only';

import { ProductOverviewAccordionTitle }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { RetailMediaCarouselFusionPIP }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { RelatedSearch }
from '@thd-olt-component-react/related-search';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSSR, ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSSR, SpecificationsAccordionBody as SpecificationsAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSSR, QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSSR, RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

export { PIPRedirector };

export { ProductMetadata };

export { Breadcrumbs };

export { ProductInfoBar };

export { Discontinued };

export { DynamicRecsWrapperPip };

export { PIPProductDetails };

export { MediaGalleryDesktop };

export { PIPSharebelt };

export { PIPSalientPoints };

export { ProExtraProductOnly };

export { ProductOverviewAccordionTitle };

export { SpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { RetailMediaCarouselFusionPIP };

export { RecentlyViewedWrapper };

export { RelatedSearch };

const SlotA1 = withLayout(
  [

    PIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    ProductMetadata,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotD1 = withLayout(
  [

    Discontinued,

  ],

);

const SlotE1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotF1 = withLayout(
  [

    PIPProductDetails,

  ],

);

const SlotF2 = withLayout(
  [

    MediaGalleryDesktop,

  ],

);

const SlotF3 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotG1 = withLayout(
  [

    PIPSalientPoints,

  ],

);

const SlotG2 = withLayout(
  [

    ProExtraProductOnly,

  ],

);

const SlotI1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotJ1 = withLayout(
  [

    RetailMediaCarouselFusionPIP,

  ],

);

const SlotK1 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotL1 = withLayout(
  [

    RelatedSearch,

  ],

);

const ssr = typeof window === 'undefined';

const SlotH1KTitle1Index0DataModelK0 = ssr
  ? ProductOverviewAccordionTitleSSR
  : {};

const SlotH1KBody1Index0DataModelBodyK0 = ssr
  ? ProductOverviewAccordionBodySSR
  : {};

const SlotH1KTitle2Index1DataModelK0 = ssr
  ? SpecificationsAccordionTitleSSR
  : {};

const SlotH1KBody2Index1DataModelBodyK0 = ssr
  ? SpecificationsAccordionBodySSR
  : {};

const SlotH1KTitle3Index2DataModelK0 = ssr
  ? QuestionsAndAnswersAccordionTitleSSR
  : {};

const SlotH1KBody3Index2DataModelBodyK0 = ssr
  ? QuestionsAndAnswersAccordionBodySSR
  : {};

const SlotH1KTitle4Index3DataModelK0 = ssr
  ? RatingsAndReviewsAccordionTitleSSR
  : {};

const SlotH1KBody4Index3DataModelBodyK0 = ssr
  ? RatingsAndReviewsAccordionBodySSR
  : {};

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotC1,

  SlotD1,

  SlotE1,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotG1,

  SlotG2,

  SlotI1,

  SlotJ1,

  SlotK1,

  SlotL1,

  SlotH1KTitle1Index0DataModelK0,

  SlotH1KBody1Index0DataModelBodyK0,

  SlotH1KTitle2Index1DataModelK0,

  SlotH1KBody2Index1DataModelBodyK0,

  SlotH1KTitle3Index2DataModelK0,

  SlotH1KBody3Index2DataModelBodyK0,

  SlotH1KTitle4Index3DataModelK0,

  SlotH1KBody4Index3DataModelBodyK0,

};